exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centered-input[data-v-c4b749d4] input,.centered-label[data-v-c4b749d4]{text-align:center}", ""]);

// exports
